module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/work/components/project-issues/project-issues.component.css
// module id = ./src/app/modules/work/components/project-issues/project-issues.component.css
// module chunks = main